<template>
    <div class="shouye">
        <div class="banner txhz"  ref="viewBox">
            <img v-if="scrollTop>300" class="logoImg" src="@/assets/logo/logoL.png" alt="">
            <img v-else class="logoImg" src="@/assets/logo/logo.png" alt="">

            <div class="lujing txhz" :class="{'ljLv' : scrollTop>300}">
                <div class="lj-son txhz  lj-sonact">
                    <div>首页</div>
                    <div class="lj-line lj-liner"></div>
                </div>
                <div class="lj-son txhz" @click="nextUrl('/information',4)">
                    <div>信息大厅</div>
                    <div class="lj-line"></div>
                </div>
                <div class="lj-son txhz" @click="nextUrl('/about_us',1)">
                    <div>关于我们</div>
                    <div class="lj-line"></div>
                </div>
                <div class="lj-son txhz" @click="nextUrl('/news',2)">
                    <div>新闻动态</div>
                    <div class="lj-line"></div>
                </div>
                <div class="lj-son txhz" @click="nextUrl('/download',3)">
                    <div>产品下载</div>
                    <div class="lj-line"></div>
                </div>
            </div>
        </div>
        <div class="dingbu">
            <el-carousel class="carousel"  height="960px" :loop="true">
                <el-carousel-item v-for="(item,index) in bannerList" :key="index">
                    <img class="lunboImg" :src="item" alt="" />
                    <div class="zhezhao"></div>
                </el-carousel-item>
            </el-carousel>

            <div class="wenzi">
                <div class="wz-tit">荷力共济 港通货达</div>
                <div class="wz-word">深耕智能物流科技，以技术革新传统货运，赋能行业转型升级；打造高品质智慧物流品牌，引领行业智能协同高质量发展。</div>
                <div class="wz-ewm txhz">
                    <div class="ewm">
                        <img class="ewmImg" src="https://serve.xiaohezy.com/resource/image/pc/consignee_qr_code.png" alt="">
                        <span>下载货主APP</span>
                    </div>
                    <div class="ewm">
                        <img class="ewmImg" src="https://serve.xiaohezy.com/resource/image/pc/driver_qr_code.png" alt="">
                        <span>下载司机APP</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- 集团介绍 -->
        <div class="jieshao">
            <img class="jzImg" src="@/assets/index/jianzhu.png" alt="">
            <img class="renImg" src="@/assets/index/jtjs.png" alt="">
            <div class="js-wz">ABUOUT US</div>
            <div class="js-nr">
                <div class="jsd-tit">{{form.title || '--'}}</div>
                <div class="js-lin">{{form.subtitle || '--'}}</div>
                <div class="js-word" v-html="form.content"></div>
                <el-button type="primary" class="chakan" @click="nextUrl('/about_us',1)">查看详情</el-button>
            </div>
        </div>

        <!-- 产品下载 -->
        <div class="chanpin">
            <div class="cptit">产品下载</div>
            <div class="cpword">小荷智运支持IOS、Android、微信小程序等版本</div>
            <div class="cpcon txhz">
                <div class="cpson" v-for="(item,index) in dataList" :key="index" 
                @mouseover="dataOver(index)" 
                @mouseleave="dataLave"
                >
                    <div v-if="item.isShow==0">
                        <img class="ewmBj" src="@/assets/index/ewmBj.png" alt="">
                        <div class="cpxiao txhz">
                            <img class="cpImg" :src="item.icon" alt="">
                            <span>{{item.name}}</span>
                        </div>
                    </div>
                    <div v-else>
                        <div class="ewmBjer"></div>
                        <div class="cpxiao txhz">
                            <img class="xiazaiImg" :src="item.url" alt="">
                            <div class="txhz">
                                <img class="litu" :src="item.icon" alt="">
                                <span>{{item.name}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="cptishi">
                下载过程遇到问题，请拨打客服热线 <span>400-808-6228</span>
            </div>
        </div>

        <!-- 用户端 -->
        <div class="yonghu yhbbj txhz">
            <img class="phoneImg bianju" src="@/assets/index/hzd.png" alt="">
            <div class="jiben">
                <div class="jbtit txhz">
                    <img class="logoImg" src="@/assets/index/hzlogo.png" alt="">
                    <span class="jbname">小荷智运</span>
                    <span class="jbtype">用户端</span>
                </div>
                <div class="jbword">打开APP填写信息即可查询运价</div>
                <div class="jbcon">
                    <div class="jbson">
                        <img class="miniImg" src="@/assets/index/miniyi.png" alt="">
                        <span>快捷便利随时随地查询运价</span>
                    </div>
                    <div class="jbson">
                        <img class="miniImg" src="@/assets/index/minier.png" alt="">
                        <span>多种运输类型可选，单拖双拖配柜配货运等任你挑选</span>
                    </div>
                    <div class="jbson">
                        <img class="miniImg" src="@/assets/index/minisan.png" alt="">
                        <span>APP支持自定义出价、监装、验箱等操作还有实时通知等功能</span>
                    </div>
                </div>

                <div class="jbbtn" @click="nextUrl('/download',3)">前往下载</div>
            </div>
        </div>
        <!-- 司机端 -->
        <div class="yonghu yhbbjer txhz">
            <div class="jiben">
                <div class="jbtit txhz">
                    <img class="logoImg" src="@/assets/index/hzlogo.png" alt="">
                    <span class="jbname">小荷智运</span>
                    <span class="jbtype">司机端</span>
                </div>
                <div class="jbword">完成认证后即可查看货源信息</div>
                <div class="jbcon">
                    <div class="jbson">
                        <img class="miniImg" src="@/assets/index/minisi.png" alt="">
                        <span>展示小荷专属货源，货源内容一目了然</span>
                    </div>
                    <div class="jbson">
                        <img class="miniImg" src="@/assets/index/miniwu.png" alt="">
                        <span>专属会员大厅，订阅常跑路线接单更轻松</span>
                    </div>
                    <div class="jbson">
                        <img class="miniImg" src="@/assets/index/minisan.png" alt="">
                        <span>APP支持车队接单、转单以及追加其他费用</span>
                    </div>
                </div>

                <div class="jbbtn" @click="nextUrl('/download',3)">前往下载</div>
            </div>
            <img class="phoneImg bianjuer" src="@/assets/index/sjd.png" alt="">
        </div>


        <!-- 新闻动态 -->
        <div class="xinwen">
            <div class="xw-tit">新闻动态</div>
            <div class="xw-word">洞察行业发展趋势，一览企业实时动态</div>

            <div>
                <div class="xw">
                    <div class="xw-left" :class="{'xw-lefter':newList.length==1}" @click="nextDetail(newForm.id)">
                        <img class="cheImg" :src="newForm.cover" alt="">
                        <div class="xw-bt txhz">
                            <span class="xw-stit">{{newForm.title || ''}}</span>
                            <span class="xw-stime">
                                {{ ymd.year  || ''}}-{{ymd.month || ''}}-{{ymd.day || ''}}
                            </span>
                        </div>
                        <div class="xw-sword">
                            {{newForm.content_desc || ''}}
                        </div>
                    </div>
                    <div class="xw-right">
                        <div class="xw-ryi txhz" 
                        v-for="(item, index) in newList.slice(1,5)" 
                        :key="index"
                        @mouseover="isHovered = index" 
                        @mouseleave="isHovered = -1"
                        @click="nextDetail(item.id)">
                            <div>
                                <div class="xw-num" :class="{'lvse' : isHovered == index}">{{item.ymd.day}}</div>
                                <div class="xw-yue" :class="{'lvse' : isHovered == index}">{{item.ymd.year}}-{{item.ymd.month}}</div>
                            </div>
                            <div class="xw-line" :class="{'lvseBj' : isHovered == index}"></div>
                            <div class="xw-ci" :class="{'lvse' : isHovered == index}">{{item.content_desc}}</div>

                            <div class="xw-jt txhz" 
                            v-if="isHovered == index"
                            @click="nextDetail(item.id)">
                                <img class="yjtImg" src="@/assets/index/youjiantou.png" alt="">
                            </div>
                        </div>
                        
                    </div>
                </div>

                <div class="news-more txhz">
                    <div class="more"  @click="nextUrl('/news',2)">
                        查看更多
                        <i class="el-icon-arrow-right"></i>
                    </div>
                </div>
            </div>
        </div>

        <!-- 最后 -->
        <div class="keji txhz">
            <div class="kj-tit">科技创新开发新模式 开启智慧货运新时代</div>
            <div class="kj-in">客户第一、科技创新、诚信经营、团队协作、持续进步</div>
            <div class="kj-btn txhz">
                <el-button class="xiazai" @click="nextUrl('/download',3)">前往下载</el-button>
                <div class="lianxi" 
                @mouseover="showEwm = true" 
                @mouseleave="showEwm=false"
                >咨询我们</div>
                <img v-if="showEwm" class="ewm" :src="kfUrl" alt="">
            </div>
        </div>

        <!-- 底部 -->
        <Bottom />
    </div>
</template>
    
<script>
import Bottom from './BottomPage.vue';
import { 
    getHomepageBanner,
    getAboutUsInfo,
    getCorporateCulture,
    newsUpdatesList,
    getQrCode,
} from "@/api/api";

export default {
    components:{
        Bottom
    },
    data(){
        return{
            isHovered:-1,
            showEwm:false,
            scrollTop:0,

            bannerList:[],

            form:{},

            wenhuaList:[],
            yiForm:{},
            erForm:{},
            sanForm:{},
            newList:[],
            newForm:{},
            ymd:{},

            kfUrl:'',


            dataList:[
                {
                    name:'IOS货主端',
                    url:'',
                    isShow:0,
                    icon:require('@/assets/index/pg.png'),
                },
                {
                    name:'IOS司机端',
                    url:'',
                    isShow:0,
                    icon:require('@/assets/index/pg.png'),
                },
                {
                    name:'Android货主端',
                    url:'',
                    isShow:0,
                    icon:require('@/assets/index/az.png'),
                },
                {
                    name:'Android司机端',
                    url:'',
                    isShow:0,
                    icon:require('@/assets/index/az.png'),
                },
                {
                    name:'小程序货主端',
                    url:'',
                    isShow:0,
                    icon:require('@/assets/index/xcx.png'),
                },
                {
                    name:'小程序司机端',
                    url:'',
                    isShow:0,
                    icon:require('@/assets/index/xcx.png'),
                }
            ],
        }
    },
    methods:{
        nextUrl(url,index){
            sessionStorage.setItem('menu',index)
            this.$router.push(url)
        },
        nextDetail(id){
            sessionStorage.setItem('menu',2)
            this.$router.push('/newsDetails?id='+id)
        },
        huadong(){
            window.document.body.onscroll = () => {
                this.scrollTop = document.documentElement.scrollTop;

                if (this.$refs.viewBox !== undefined && this.$refs.viewBox !== null) {
                    if(document.documentElement.scrollTop> 300){
                        this.$refs.viewBox.style.background = "#FFFFFF";
                        this.$refs.viewBox.style.boxShadow =
                        "0px 10px 20px 0px rgba(0,0,0,0.05)";
                    }else{
                        this.$refs.viewBox.style.background = "transparent";
                        this.$refs.viewBox.style.boxShadow =
                        "0px 0px 0px 0px rgba(0,0,0,0)";
                    }
                }
            };
        },
        async getBanner(){
            try {
                const res = await getHomepageBanner()
                this.bannerList = res.data
            } catch (error) {
                console.log(error,'error');
            }
        },
        async getWomen(){
            try {
                const res = await getAboutUsInfo()
                this.form = res.data || {}
            } catch (error) {
                console.log(error,'error');
            }
        },
        async getQiyewh(){
            try {
                const res = await getCorporateCulture()
                this.wenhuaList = res.data
                this.yiForm = res.data[0] || {}
                this.erForm = res.data[1] || {}
                this.sanForm = res.data[2] || {}
            } catch (error) {
                console.log(error,'error');
            }
        },
        async getXinwen(){
            try {
                const res = await newsUpdatesList({
                    page_no:1,
                    page_size:5
                })
                this.newList = res.data.lists

                this.newForm = this.newList[0]
                this.ymd = this.newForm.ymd

            } catch (error) {
                console.log(error,'error');
            }
        },
        async getErwm(){
            try {
                const res = await getQrCode()
                this.kfUrl = res.data.customer_service

                
                this.dataList[0].url = res.data.user_ios_app
                this.dataList[1].url = res.data.driver_ios_app
                this.dataList[2].url = res.data.user_android_app
                this.dataList[3].url = res.data.driver_android_app
                this.dataList[4].url = res.data.user_wechat_applet
                this.dataList[5].url = res.data.driver_wechat_applet
            } catch (error) {
                console.log(error,'error');
            }
        },
        dataOver(index){
            this.dataList[index].isShow = 1
        },
        dataLave(){
            for (let i = 0; i < this.dataList.length; i++) {
                this.dataList[i].isShow = 0
            }
        },
    },
    mounted(){
        this.getBanner()
        this.getWomen()
        this.getQiyewh()
        this.getXinwen()
        this.huadong()
        this.getErwm()
    }
}
</script>
    
<style style lang="scss" scoped>
.banner{
    position: fixed;
    top: 0px;
    // left: 50%;
    // transform: translate(-50%);

    width: 100%;
    padding: 0px 160px;
    height: 80px;
    justify-content: space-between;
    box-sizing: border-box;

    z-index: 9999;
    .logoImg{
        width: 152px;
        height: 52px;
    }
}

.lujing{
    .lj-son{
        cursor: pointer;
        flex-direction: column;

        color: #EEEEEE;
        font-size: 18px;

        margin-right: 80px;
    }

    .lj-sonact{
        color: #fff;
    }

    .lj-line{
        width: 48px;
        height: 4px;
        margin-top: 12px;
    }

    .lj-liner{
        background: #FFF;
    }
}

.ljLv{
    .lj-son{
        color: #666666;
    }

    .lj-sonact{
        color: #0EDE98;
    }

    .lj-liner{
        background: #0EDE98;
    }
}

.dingbu{
    width: 100%;
    height: 960px;
    position: relative;

    // .carousel{
    //     height: 960px;
    // }

    .zhezhao{
        width: 100%;
        height: 960px;
        background: rgba($color: #000000, $alpha: 0.2);
        position: absolute;
        top: 0px;
        left: 0px;
        z-index: 97;
    }

    .lunboImg{
        width: 100%;
        height: 960px;
        object-fit: cover;
    }
    :deep(.el-carousel){
        .el-carousel__arrow{
            width: 76px;
            height: 76px;
            background: rgba($color: #fff, $alpha: 0.4);

            .el-icon-arrow-left{
                font-size: 36px;
            }

            .el-icon-arrow-right{
                font-size: 36px;
            }
        }
    }

    .wenzi{
        position: absolute;
        top: 248px;
        left: 180px;
        width: 720px;
        z-index: 99;
        // text-align: center;

        .wz-tit{
            color: #FFF;
            font-size: 48px;
        }

        .wz-word{
            color: #FFF;
            font-size: 24px;
            margin-top: 8px;
        }

        .wz-ewm{
            margin-top: 48px;
        }

        .ewm{
            width: 138px;
            height: 156px;
            border-radius: 12px;
            background: #FFF;
            padding: 10px 10px 4px;
            box-sizing: border-box;
            text-align: center;

            color: #333;
            font-size: 14px;

            margin-right: 30px;
        }

        .ewmImg{
            width: 118px;
            height: 118px;
            background: #D9D9D9;
            // margin-bottom: 4px;
        }
    }
}

.jieshao{
    height: 680px;
    background: linear-gradient(180deg, #FEFEFE 0%, #FEFEFE 100%);
    position: relative;
    .jzImg{
        width: 100%;
        height: 334px;

        position: absolute;
        bottom: 0px;
        left: 0px;

        // background: url(@/assets/index/jianzhuY.png) lightgray -13.342px -236.125px / 74.822% 241.758% no-repeat;
    }

    .renImg{
        width: 1000px;
        height: 680px;
        position: absolute;
        bottom: 0px;
        right: 0px;
    }

    .js-wz{
        color: #EFEFEF;
        font-size: 68px;

        position: absolute;
        top: 100px;
        left: 160px;
        z-index: 98;
    }

    .js-nr{
        width: 680px;

        position: absolute;
        top: 137px;
        left: 160px;
        z-index: 99;

        .jsd-tit{
            color: #000;
            font-size: 40px;
        }

        .js-lin{
            color: #333;
            font-size: 24px;
            margin-bottom: 32px;
            margin-top: 34px;
        }

        .js-word{
            color: #666;
            font-size: 16px;
            line-height: 24px;

            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 10;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .chakan{
            width: 168px;
            height: 60px;
            border-radius: 12px;
            background: #0EDE98;
            font-size: 16px;
            margin-top: 77px;
        }
    }
}

.chanpin{
    height: 686px;
    background: #fff;

    .cptit{
        padding-top: 100px;
        text-align: center;
        
        color: #000;
        font-size: 40px;
    }

    .cpword{
        padding-top: 24px;
        text-align: center;
        
        color: #000;
        font-size: 16px;
    }

    .cpcon{
        justify-content: center;
        margin-top: 80px;
    }

    .cpson{
        width: 200px;
        height: 200px;
        position: relative;
        margin-left:30px;
        margin-right:30px;
    }

    .ewmBj{
        width: 200px;
        height: 200px;
    }

    
    .ewmBjer{
        width: 200px;
        height: 200px;
        background: #fff;
        filter: drop-shadow(0 0 16.129px rgba(65, 63, 78, 0.10));
        border-radius: 24px;
    }

    .xiazaiImg{
        width: 140px;
        height: 140px;
        margin-bottom: 12px;
    }

    .litu{
        width: 24px;
        height: 24px;
        margin-right: 8px;
    }

    .cpxiao{
        position: absolute;
        top: 0px;
        left: 0px;
        width: 200px;
        height: 200px;
        justify-content: center;
        flex-direction: column;

        .cpImg{
            width: 52px;
            height: 52px;
            margin-bottom: 24px;
        }
    }

    .cptishi{
        margin-top: 80px;
        font-size: 14px;
        color: #555F6E;
        text-align: center;
        span{
            color: #00C37D;
        }
    }
}

.yonghu{
    height: 791px;
    padding: 68px 380px;
    box-sizing: border-box;
    .phoneImg{
        width: 420px;
        height: 654px;
    }

    .jiben{
        .logoImg{
            width: 62px;
            height: 62px;
            margin-right: 20px;
        }

        .jbname{
            color: #000;
            margin-right: 16px;
            font-size: 32px;
        }

        .jbtype{
            display: inline-block;
            color: #666;
            font-size: 24px;
            padding: 4px 12px;
            border-radius: 8px;
            border: 1px solid #999;
        }

        .jbword{
            color: #333;
            font-size: 24px;
            margin-top: 60px;
        }

        .jbcon{
            margin-top: 32px;
        }

        .jbson{
            color: #333;
            font-size: 16px;
            margin-bottom: 20px;
            display: flex;
            align-items: center;
            .miniImg{
                width: 20px;
                height: 20px;
                margin-right: 9px;
            }
        }

        .jbbtn{
            width: 168px;
            height: 60px;
            border-radius: 12px;
            background: #00C37D;
            margin-top: 48px;
            color: #FFF;
            font-size: 16px;
            text-align: center;
            line-height: 60px;
            cursor: pointer;
        }
    }
}

.bianju{
    margin-right: 239px;
}

.bianjuer{
    margin-left: 239px;
}

.yhbbj{
    background: #F9F9F9;
}

.yhbbjer{
    background: #fff;
    justify-content: space-between;
}

.xinwen{
    height: 1000px;
    background: #F9F9F9;

    margin: 0px 160px;
    
    .xw-tit{
        color: #000;
        font-size: 40px;
        text-align: center;
        padding-top: 80px;
        z-index: 99;
    }

    .xw-word{
        color: #333;
        font-size: 24px;
        margin-top: 16px;
        margin-bottom: 68px;
        text-align: center;
    }

    .xw{
        display: flex;

        .xw-left{
            width: 800px;
            cursor: pointer;
        }
        .xw-lefter{
            flex: 1;
            cursor: pointer;
        }

        .cheImg{
            width: 100%;
            height: 520px;
            margin-bottom: 24px;
            object-fit: cover;
            border-radius: 20px;
        }

        .xw-bt{
            justify-content: space-between;
        }

        .xw-stit{
            display: inline-block;
            width: 480px;
            overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
            color: #000;
            font-size: 20px;
        }

        .xw-stime{
            color: #999;
            font-size: 16px;
        }

        .xw-sword{
            width: 100%;
            color: #666;
            font-size: 16px;
            overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
            margin-top: 8px;
        }

        .xw-right{
            margin-left: 40px;

            .xw-ryi{
                width: 760px;
                height: 120px;
                border-radius: 20px;
                background: #fff;
                margin-bottom: 40px;
                padding: 24px 0px 24px 24px;
                box-sizing: border-box;
                cursor: pointer;
                .xw-num{
                    color: #999;
                    font-size: 40px;
                    font-weight: 400;
                    text-align: center;
                }

                .xw-yue{
                    color: #999;
                    font-size: 16px;
                    text-align: center;
                }

                .xw-line{
                    width: 2px;
                    height: 76px;
                    background: #CCC;
                    margin-left: 24px;
                    margin-right: 24px;
                }

                .xw-ci{
                    // width: 594px;
                    flex: 1;
                    color: #666;
                    font-size: 16px;

                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 3;

                    overflow: hidden;
                    text-overflow: ellipsis;

                    margin-right: 24px;
                }

                .xw-jt{
                    width: 80px;
                    height: 120px;
                    border-radius: 0 20px 20px 0;
                    background: #0EDE98;
                    justify-content: center;
                    cursor: pointer;
                }

                .yjtImg{
                    width: 32px;
                    height: 32px;
                }

                .lvse{
                    color: #0EDE98;
                }

                .lvseBj{
                    background: #0EDE98;
                }
            }
        }
    }

    .news-more {
        margin-top: 12px;
        color: #333;
        font-size: 16px;
        justify-content: center;
        .more{
            cursor: pointer;
            width: 168px;
            height: 60px;
            color: #00C37D;
            border-radius: 12px;
            border: 1px solid #00C37D;
            text-align: center;
            line-height: 60px;
        }
    }

}

.keji{
    height: 413px;
    background: #fff;
    flex-direction: column;
    justify-content: center;

    .kj-tit{
        color: #0EDE98;
        font-size: 48px;
        font-weight: 400;
    }

    .kj-in{
        color: #333;
        font-size: 16px;
        font-weight: 400;
        margin-top: 16px;
        margin-bottom: 48px;
    }

    .xiazai{
        width: 168px;
        height: 60px;
        border-radius: 12px;
        background: #333;
        color: #FFF;
        font-size: 16px;
    }

    .lianxi{
        width: 168px;
        height: 60px;
        border-radius: 12px;
        border: 1px solid #333;
        color: #333;
        font-size: 16px;
        background: #fff;
        cursor: pointer;
        text-align: center;
        line-height: 60px;
        margin-left: 24px;
    }

    .kj-btn{
        position: relative;
    }

    .ewm{
        position: absolute;
        right: 34px;
        top: -114px;
        width: 100px;
        height: 100px;
    }
}

.txhz{
    display: flex;
    align-items: center;
}
</style>